import { Component, Input } from '@angular/core';
import { KnownIssuesTableSection } from 'src/app/model/shared/known-issues-table-section';

import { documentToHtmlString } from '../table-section';

@Component({
  selector: 'app-known-issues-table-section',
  templateUrl: './known-issues-table-section.component.html',
  styleUrls: ['./known-issues-table-section.component.scss']
})
export class KnownIssuesTableSectionComponent {
  @Input() tableSections: KnownIssuesTableSection[] = [];
  constructor() {}

  returnHtmlFromRichText(richText: any): string {
    if (richText === undefined || richText === null || richText.nodeType !== 'document') {
      return '<p>Error</p>';
    }

    return documentToHtmlString(richText);
  }
}
